import { Button } from '@/ui/button/button';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { ParagraphSmall } from '@/ui/typography/widgets';
import { useTranslation } from 'react-i18next';
import SvgEmptyStateFiles from '@/assets/widgets/empty-state-files.svg';

export const FeedEmptyState = ({
  onUploadButtonClick,
}: {
  onUploadButtonClick: () => void;
}) => {
  const { t } = useTranslation('settings', { keyPrefix: 'feedTab' });

  return (
    <Flexbox
      name="no-results-container"
      direction="column"
      gap="16px"
      alignItems="center"
      justify="center"
      height="484px"
    >
      <img src={SvgEmptyStateFiles} />
      <ParagraphSmall>{t`noArticles`}</ParagraphSmall>

      <Button startIcon="Plus" onClick={onUploadButtonClick}>
        {t`upload`}
      </Button>
    </Flexbox>
  );
};
